import { render, staticRenderFns } from "./outboundTasks.vue?vue&type=template&id=634667bc&scoped=true&"
import script from "./outboundTasks.vue?vue&type=script&lang=js&"
export * from "./outboundTasks.vue?vue&type=script&lang=js&"
import style0 from "./outboundTasks.vue?vue&type=style&index=0&id=634667bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634667bc",
  null
  
)

export default component.exports